import { render } from "./JobProfessionalValuesTableSection.vue?vue&type=template&id=700c5ce9"
import script from "./JobProfessionalValuesTableSection.vue?vue&type=script&lang=js"
export * from "./JobProfessionalValuesTableSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__